<template>
  <div>
    <div v-if="!isInDetail" class="fund-list-title">
      <span>{{ name }}的投资案例</span>
      <el-button type="text" size="mini" @click="handleAdd">添加</el-button>&nbsp;&nbsp;
      <i class="fund-close el-icon el-icon-close" @click="handlerClose"></i>
    </div>
    <div
      v-if="investmentCase && investmentCase.length > 0"
      :class="isInDetail ? '' : 'radish-dia-body'"
      style="padding-bottom: 15px;"
    >
      <el-table :data="investmentCase" size="mini">
        <el-table-column v-if="!isInDetail" label="操作" width="150" :resizable="false">
          <template slot-scope="scope">
            <el-button type="text" size="mini" @click="handleMark(scope.row)">{{
              scope.row.isMain ? '取消主管' : '标为主管'
            }}</el-button>
            <el-button type="text" size="mini" @click="handleQuit">退出</el-button>
            <el-button type="text" size="mini" @click="handleDel(scope.row)">删除</el-button>
          </template>
        </el-table-column>
        <el-table-column label="项目名称" prop="名称"></el-table-column>
        <el-table-column label="投资轮次" width="120"
          ><template slot-scope="scope">
            {{ scope.row.投资轮次 || '--' }}</template
          ></el-table-column
        >
        <el-table-column label="行业领域"
          ><template slot-scope="scope">
            {{ scope.row.行业 || '--' }}</template
          ></el-table-column
        >
        <el-table-column label="业务"
          ><template slot-scope="scope">
            {{ scope.row.业务 || '--' }}</template
          ></el-table-column
        >
        <el-table-column label="当前轮次" width="120"
          ><template slot-scope="scope">
            {{ scope.row.轮次 || '--' }}</template
          ></el-table-column
        >
        <el-table-column width="50" label="主投">
          <template slot-scope="scope">
            <el-checkbox
              v-model="scope.row.主投"
              class="huoban-checkbox"
              size="mini"
              @change.native="saveCases"
            ></el-checkbox>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-dialog title="添加投资案例" :visible.sync="dialogVisible" modal append-to-body>
      <div>案例名称: <el-input v-model="newCase.名称" placeholder="请填写案例名称"> </el-input></div>
      <div>案例名称: <el-input v-model="newCase.投资轮次" placeholder="请填写投资轮次"> </el-input></div>
      <div>案例行业: <el-input v-model="newCase.行业" placeholder="请填写案例行业"> </el-input></div>
      <div>案例业务: <el-input v-model="newCase.业务" placeholder="请填写案例业务"> </el-input></div>
      <div>案例轮次: <el-input v-model="newCase.轮次" placeholder="请填写案例轮次"> </el-input></div>
      <div>案例是否主投: <el-checkbox v-model="newCase.主投" placeholder="请选择是否主投"> </el-checkbox></div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="confirmAdd">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: 'InvestCasesList',
  props: {
    name: { type: String, default: '' },
    rid: { type: String, defalut: '' },
    isInDetail: { type: Boolean, default: false },
    cases: { type: Array, default: () => [] },
  },
  data: function() {
    return {
      investmentCase: [],
      dialogVisible: false,
      newCase: {
        名称: '',
        行业: '',
        业务: '',
        轮次: '',
        主投: false,
        投资轮次: '',
      },
    }
  },
  watch: {
    cases: {
      handler(val) {
        this.investmentCase = val
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    async handleMark(row) {
      const mainCase = []
      this.investmentCase = this.investmentCase.map(f => {
        if (f.名称 == row.名称) {
          f.isMain = !f.isMain
        }
        if (f.isMain) {
          mainCase.push(f.名称)
        }
        return f
      })
      const res = await app.service('radish').modifyById({ _id: this.rid, data: { 主管案例: mainCase } })
      if (res.status === 'success') {
        this.$emit('mark', mainCase)
      } else {
        this.$message.error(res.msg)
      }
    },
    handleQuit() {
      this.$emit('quit')
    },
    async handleDel(row) {
      const investmentCase = this.investmentCase.filter(ca => ca.名称 != row.名称)
      this.investmentCase = investmentCase
      const res = await app.service('radish').modifyById({ _id: this.rid, data: { 投资案例: investmentCase } })
      if (res.status === 'success') {
        this.$emit('change', investmentCase)
      } else {
        this.$message.error(res.msg)
      }
    },
    handleAdd() {
      this.dialogVisible = true
    },
    async saveCases() {
      const res = await app.service('radish').modifyById({ _id: this.rid, data: { 投资案例: this.investmentCase } })
      if (res.status === 'success') {
        this.$message.success(`案例添加成功`)
        this.newCase = {
          名称: '',
          行业: '',
          业务: '',
          轮次: '',
          主投: false,
          投资轮次: '',
        }
        this.$emit('change', this.investmentCase)
      } else {
        this.$message.error(res.msg)
      }
    },
    async confirmAdd() {
      this.investmentCase.unshift(this.newCase)
      await this.saveCases()
      this.dialogVisible = false
    },
    handlerClose() {
      this.$emit('close')
    },
  },
}
</script>
